export function isValidForm (data) {
  return !!data.email && data.password
}